import { useMutation } from '@tanstack/react-query';

import FileProcessingApiHandler from 'app/services/fileProcessingApiHandler';
import { useToast, buildError } from '@aslanpay/portal-common-lib';

export interface ConfirmAETFileRequest {
  fileUploadId: string;
}

const useConfirmAETFile = (options?: { onSuccess?: () => void; onError?: () => void }) => {
  const toast = useToast();

  return useMutation<void, Error, ConfirmAETFileRequest>(
    ({ fileUploadId }) => FileProcessingApiHandler.confirmFileUpload(fileUploadId),
    {
      onSuccess: () => {
        toast({
          position: 'top-right',
          status: 'success',
          title: 'Success',
          description:
            'Timesheet has been confirmed and is processing... please wait for the confirmation email.',
        });
        options?.onSuccess?.();
      },
      onError: (error) => {
        const errorMessage = buildError(
          error,
          'Sorry, it was not possible to confirm your timesheet upload. Please try again.'
        );

        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: errorMessage,
        });
        options?.onError?.();
      },
    }
  );
};

export default useConfirmAETFile;
